import type { ConnectionState } from '@/lib/ws';

/** Message type identifiers from the WebSocket protocol */
export const MessageType = {
    CONNECTED: '0',
    PRICE: '1',
    ERROR: '2',
    PING: '3',
    PING_RTT: '4',
} as const;

export type MessageTypeValue = (typeof MessageType)[keyof typeof MessageType];

/** Parsed message from the price feed */
export type ParsedMessage =
    | { type: '0'; pair: string }
    | { type: '1'; price: number }
    | { type: '2'; error: string }
    | { type: '3'; timestamp: string }
    | { type: '4'; rtt: number }
    | { type: 'unknown'; raw: string };

/** Return type for the usePriceFeed hook */
export interface PriceFeedState {
    /** Current price (null before first update) */
    price: number | null;
    /** WebSocket connection state */
    connectionState: ConnectionState;
    /** Server has acknowledged connection with pair confirmation */
    isServerReady: boolean;
    /** Current round-trip time in milliseconds */
    latency: number | null;
    /** Last error message from server */
    error: string | null;
    /** Data is stale (no update for threshold period) */
    isStale: boolean;
    /** Manually trigger reconnection */
    reconnect: () => void;
}

/** Staleness threshold in milliseconds. Client pings every 5s; allow missed jitter. */
export const STALE_THRESHOLD_MS = 15000;
